import React from 'react';
import {Field, Formik} from "formik";
import closeIcon from "../../../images/white-close.svg";
import arrow from "../../../images/arrow-right.svg";
import {validateEmail} from "../../../utils";
import {useTranslation} from "react-i18next";

const SendBlock = ({emails, setEmails}) => {
  const {t} = useTranslation()
  return (
    <>
      <div className="modal__content mb-12">
        <p className="modal__caption">{t('recipients')} {emails.length > 0 && `(${emails.length})`}:</p>
      </div>
      <Formik
        initialValues={{
          email: ''
        }}
        onSubmit={({email}, {resetForm}) => {
          if(emails.indexOf(email) === -1) {
            setEmails([...emails, email])
          }
          resetForm()
        }}
      >
        {({values, handleChange, handleSubmit, setFieldValue}) => {
          return <div className="modal__inputItem modal__row m-0">
            <div className={`modal__date col ${emails.length !== 0 && 'pv-12'}`}>
              {emails.length !== 0 && <div className="modal__users mb-24">
                {emails.map((email, index) => <div className="modal__user" key={index}>
                  {email}
                  <button onClick={() => setEmails([...emails].filter(e => e !== email))}>
                    <img src={closeIcon} alt=""/>
                  </button>
                </div>)}
              </div>}
              <div className="modal__dateItem w-100 m-0">
                <Field id={'email'} required={true} value={values.email} onBlur={(e) => {
                  if(validateEmail(e.target.value) && emails.indexOf(e.target.value) === -1) {
                    setEmails([...emails, e.target.value])
                  }
                  setFieldValue('email', '')
                }} onChange={(e) => {
                  handleChange(e)
                  const currentString = e.target.value
                  if(currentString.indexOf(' ') !== -1 || currentString.indexOf(',') !== -1) {
                    if(validateEmail(currentString.split(' ')[0]) && emails.indexOf(currentString.split(' ')[0]) === -1) {
                      setEmails([...emails, currentString.split(' ')[0]])
                      setFieldValue('email', '')
                    }
                    if(validateEmail(currentString.split(',')[0]) && emails.indexOf(currentString.split(',')[0]) === -1) {
                      setEmails([...emails, currentString.split(',')[0]])
                      setFieldValue('email', '')
                    }
                  }
                }}
                       onKeyDown={e => {
                        if(e.keyCode === 13) handleSubmit()
                       }}
                       placeholder={t('enterRecMail')} className={'modal__dateInput w-100'}
                       type="text"/>
              </div>
            </div>
            {/*<button onClick={handleSubmit} autoFocus={true} className="modal__send ml-16 hidden-block">*/}
            {/*  <img src={arrow} alt=""/>*/}
            {/*</button>*/}
          </div>
        }}
      </Formik>
    </>
  );
};

export default React.memo(SendBlock);
